//=====================================================
// メイン
//=====================================================

import { useContext, useEffect } from 'react';
import { Route, Switch, useHistory, useLocation } from 'react-router-dom';
import { CtxClinicInfo, CtxNewReservation, CtxSystemErr } from '../../utils/Contexts';
import { G001 } from '../../pages/G001/G001';
import { G002 } from '../../pages/G002/G002';
import { G003 } from '../../pages/G003/G003';
import { G004 } from '../../pages/G004/G004';
import { G005 } from '../../pages/G005/G005';
import { G006 } from '../../pages/G006/G006';
import { G007 } from '../../pages/G007/G007';
import { G008 } from '../../pages/G008/G008';
import { G009 } from '../../pages/G009/G009';
import { G019 } from '../../pages/G019/G019';
import { G020 } from '../../pages/G020/G020';
import { G021 } from '../../pages/G021/G021';
import { G022 } from '../../pages/G022/G022';
import { G023 } from '../../pages/G023/G023';
import { G999 } from '../../pages/G999/G999';
import { G900 } from '../../pages/G900/G900';
import { ReservationType } from '../../utils/ConstCommon';
import ReactGA from 'react-ga4'
import TagManager from 'react-gtm-module'

interface IFGaPropsOptions {
    name: string
}
interface IFGaProps {
    trackingId: string,
    gaOptions: IFGaPropsOptions
}

export function Main(){
    const cci = useContext(CtxClinicInfo);
    const cnr = useContext(CtxNewReservation);  //予約情報
    const history = useHistory();
    const location = useLocation();

    //CtxSystemErrにhistoryを設定
    const cserr = useContext(CtxSystemErr);
    useEffect(function(){
        cserr.setHistory(history);
    }, [cserr, history]);
    
    //スクロール位置指定
    if (location.pathname !== '/reservation/date/weekly'){
        window.scrollTo(0, 0);
    }

    //途中リロード対策（予約画面）
    if (location.pathname.indexOf('reservation') > 0 ){
        if (cnr.type === ReservationType.None){
            history.push('/');
        }
    }
    //途中リロード対策（キャンセル画面）
    if ( location.pathname.indexOf('mypage/cancel') > 0 ){
        if (cnr.type === ReservationType.None){
            history.push('/mypage');
        }
    }
    function onBeforeUnload(e: BeforeUnloadEvent){
        e.preventDefault();
        e.returnValue = '';
    }
    useEffect(function(){
        //リロード対策
        if (location.pathname.indexOf('reservation') > 0 || 
            location.pathname.indexOf('mypage/cancel') > 0 ){
            window.addEventListener('beforeunload', onBeforeUnload, false);
            return function(){
                window.removeEventListener('beforeunload', onBeforeUnload, false);
            }
        }
    }, [location.pathname]);

    useEffect(() => {
        const gaInitParam: IFGaProps[] = [];
        if(cci.data.gaTargetId){
            const gaTargetId = cci.data.gaTargetId.split(",");
            let name = "g-";
            let i = 1;
            gaTargetId.forEach((id: string) => {
                if(id.startsWith('G-')){
                    gaInitParam.push({trackingId: id, gaOptions: { name: name + i }});
                    i++;
                }else if(id.startsWith('GTM-')){
                    TagManager.initialize({ gtmId: id });
                }
            });
            if (gaInitParam.length > 0){
                ReactGA.initialize(gaInitParam);
            }
        }
    }, [cci.data.gaTargetId]);

    return (
        <div className='main'>
            <Switch>
                <Route exact path='/' component={G001}/>
                <Route exact path='/reservation/menu' component={G002}/>
                <Route exact path='/reservation/date/:mode' component={G003}/>
                <Route exact path='/reservation/patient' component={G004}/>
                <Route exact path='/reservation/symptoms' component={G005}/>
                <Route exact path='/reservation/confirm' component={G006}/>
                <Route exact path='/reservation/complete' component={G007}/>
                <Route exact path='/login' component={G008}/>
                <Route exact path='/mypage' component={G009}/>
                <Route exact path='/mypage/cancel' component={G019}/>
                <Route exact path='/mypage/cancel/complete' component={G020}/>
                <Route exact path='/mypage/user' component={G021}/>
                <Route exact path='/mypage/user/complete' component={G022}/>
                <Route exact path='/mypage/history' component={G023}/>
                <Route exact path='/line/login' component={G900} />　
                <Route exact path='/error' component={G999}/>
                <Route><G999 /></Route>
            </Switch>
        </div>
    )

}



